import { Component, OnChanges, Input, SimpleChanges } from '@angular/core';
import { MdDialog } from '@angular/material';
import { SliderCvComponent } from '../slider-cv/slider-cv.component';
import { ApplicantFilter } from '../../interfaces/filters';
import { JobsOffersApplicant } from '../../models/jobs-offers-applicant';
import { JobsOffer } from '../../models/jobs-offer';
import { OfferStore } from '../state/offer.store';
import { Observable } from 'rxjs/Observable';
import { InviteService } from '../../services/invite.service';
import { Invite } from '../../models/invite';
import { JobSelectorDialogComponent } from '../job-selector-dialog/job-selector-dialog.component'
import { MessageBoxDialog } from '../message-box/message-box.component';
import { MessageBoxInviteDialog } from '../message-box-invite/message-box-invite.component';

@Component({
  selector: 'app-list-candidates',
  templateUrl: './list-candidates.component.html',
  styleUrls: ['./list-candidates.component.css']
})
export class ListCandidatesComponent implements OnChanges {

  @Input() applicantFilter: ApplicantFilter;
  @Input() requirement: boolean;
  @Input() jobId: string;

  maxCandidates: number = 10;
  errorMessage: string;
  loading: Observable<boolean>;
  size: Observable<number>;
  total: Observable<number>;

  premium:string;

  constructor(private dialog: MdDialog,
              public offerStore: OfferStore,
              private inviteService:InviteService) {
    if (localStorage.getItem('premium')){
      this.premium = localStorage.getItem('premium');
    } else {
      this.premium = '0';
    }
                
    this.loading = this.offerStore.loading.share();
    this.size = this.offerStore.offers.map((offers: JobsOffer[]) => offers.length);
    this.total = this.offerStore.getTotal;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if(propName === 'requirement') {
        let chng = changes[propName];
        if(chng.previousValue != chng.currentValue) {
          this.refreshListing(1);
        }
      }
    }
  }

  refreshListing(page: number) {
    if (this.jobId) {
      this.offerStore.changeFilters(this.applicantFilter, this.requirement, page, this.maxCandidates, this.jobId); 
    } else {
      this.offerStore.changeFilters(this.applicantFilter, this.requirement, page, this.maxCandidates); 
    }
  }

  openCV(selectedIndex) {
    this.dialog.open(SliderCvComponent, {
      data: {selected: selectedIndex, filters:this.applicantFilter, requirement: this.requirement, jobInvite:this.jobId}
    });
  }

  //noinspection JSMethodCanBeStatic
  percMandatory(offer:JobsOffersApplicant): number {
    if(offer.mandatoryrequirements > 0) {
      return Math.floor(offer.mandatoryrequirementsmet / offer.mandatoryrequirements * 100);
    } else {
      return 0;
    }
  }

  //noinspection JSMethodCanBeStatic
  percDesirable(offer:JobsOffersApplicant): number {
    if(offer.desirablerequirements > 0) {
      return Math.floor(offer.desirablerequirementsmet / offer.desirablerequirements * 100);
    } else {
      return 0;
    }
  }

  onInvite(userId) {
    // if (this.jobId != undefined) {
    //   this.onPostInviteById(userId);
    // } else {
      this.openDialogJobSelectorDialog(userId);
  //  }
  }

  openDialogJobSelectorDialog(userId) {
    let dialogRef = this.dialog.open(JobSelectorDialogComponent);
    dialogRef.componentInstance.createInvite=true;
    dialogRef.componentInstance.UserID=userId;
    dialogRef.componentInstance.nameComponent='Invitación';
    dialogRef.componentInstance.hv='0';

    dialogRef.afterClosed().subscribe(result => {
      if (result != "YES") {
        // this.dialog.open(MessageBoxDialog, {data: {message: 'Invitación Enviada', success: true, showIcon:true}});
      }
    });
  }

  onPostInviteById(id) {
    let invitations = [{
        "job_id":this.jobId,
        "user_id":id}];

    this.inviteService.postInvite(invitations)
      .subscribe(
        data => {
          this.dialog.open(MessageBoxInviteDialog, {data: {data: data, success: true, showIcon:true}});
        },
        error => {
          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', message: error.message, alert: true, showIcon: true}});
        }
      );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/list-candidates/list-candidates.component.ts